<template>
    <el-dialog title="新增租户权限" width="40%" :close-on-click-modal="false" append-to-body :visible.sync="visible">
        <el-form size="small" :model="form" ref="form" label-width="140px" :rules="dataRule" v-loading="loading">
            <el-form-item label="租户名称：" prop="temporaryAuthorityId">
                <el-select v-model="form.temporaryAuthorityId" placeholder="请选择" filterable @change="selTenantName">
                    <el-option
                            v-for="item in tenantOpt"
                            :key="item.id"
                            :label="item.tenantName"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="设置权限：" prop="menuIds">
                <el-tree
                        :data="menuList"
                        :props="defaultProps"
                        node-key="id"
                        ref="menuListTree"
                        show-checkbox>
                </el-tree>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick :disabled="loading">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                loading: false,
                tenantOpt: [],
                form: {
                    userId: '',
                    temporaryAuthorityId: '',
                    menuIds: '',
                },
                defaultProps: {
                    label: 'name',
                    children: 'children',
                },
                menuList: [],
                dataRule: {
                    temporaryAuthorityId: [
                        {required: true, message: '租户名称不能为空', trigger: 'change'}
                    ],
                    menuIds: [
                        {required: true, message: ' ', trigger: 'blur'}
                    ],
                },
            }
        },
        methods: {
            init(userId, temporaryAuthorityId, method) {
                this.form.userId = userId
                this.menuList = []
                this.visible = true
                this.$nextTick(() => {
                    this.getAllTenant()
                    this.$refs.menuListTree.setCheckedKeys([])
                    this.$refs.form.resetFields();
                })
            },
            // 获取租户名称
            getAllTenant() {
                this.$axios(this.api.user.selectAllTenant, {userId: this.form.userId}).then(res => {
                    if (res.status) {
                        this.tenantOpt = res.data
                        if(this.tenantOpt.length) {
                            this.selTenantName(this.tenantOpt[0].id)
                        }
                    }
                })
            },
            // 选择租户名称
            selTenantName(val) {
                this.form.temporaryAuthorityId = val
                this.getMenu(val)
            },
            // 获取所有菜单
            getMenu(tenantId) {
                this.loading = true
                this.$axios(this.api.user.findAllTenantMenu, {tenantId}, 'get').then(data => {
                    if (data.status) {
                        this.menuList = data.data
                    }
                    this.loading = false
                })
            },
            // 确定
            doSubmit() {
                let menuIds = this.$refs.menuListTree.getCheckedKeys().concat(this.$refs.menuListTree.getHalfCheckedKeys()).join(',')
                if (!menuIds) {
                    this.$message.error('请至少选择一项租户功能权限')
                    return
                }
                this.form.menuIds = menuIds
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.$axios(this.api.user.moreTenantSave, this.form, 'post').then(data => {
                            if (data.status) {
                                this.$message.success('操作成功')
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">

</style>
